import script from "./CoreUiChatHistorySystemMessage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistorySystemMessage.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistorySystemMessage.vue?vue&type=style&index=0&id=38a82ac0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a82ac0"]])

export default __exports__